import React, { useRef, useState } from "react";
import { api } from "./lib/api";

// المرحلة 2 — مكوّن واحد مشترك لرفع صورة الرسالة والحصول على media_id.
// يُستهلك في كل شاشات الإرسال. فحص قيود ميتا (JPEG/PNG · ≤5MB) مرة واحدة هنا.
// props: value (media_id|null) · onChange(media_id|null) · testidPrefix
const MAX = 5 * 1024 * 1024;
const OK_TYPES = ["image/jpeg", "image/png"];

export default function ImagePicker({ value, onChange, testidPrefix = "image-picker", label,
  endpoint = "/whatsapp/media/upload-image", resultKey = "media_id", onResult, readyNote }) {
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [preview, setPreview] = useState(null);
  const fileRef = useRef(null);

  const onFile = async (e) => {
    const f = e.target.files?.[0];
    setErr("");
    if (!f) return;
    if (!OK_TYPES.includes(f.type)) { setErr("يقبل ميتا JPEG أو PNG فقط."); return; }
    if (f.size > MAX) { setErr("حجم الصورة يتجاوز 5MB (الحد الأقصى لدى ميتا)."); return; }
    setPreview(URL.createObjectURL(f));
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const r = await api.post(endpoint, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(r.data?.[resultKey] || null);
      if (onResult) onResult(r.data || null);
    } catch (ex) {
      setErr(ex?.response?.data?.detail || "تعذّر رفع الصورة");
      onChange(null);
    } finally { setBusy(false); }
  };

  return (
    <div data-testid={`${testidPrefix}-block`} style={{ display: "grid", gap: 6, padding: 10, background: "#FEF6EC", borderRadius: 10, border: "1px solid #F5D9B0" }}>
      <label style={{ fontSize: 12, fontWeight: 800, color: "#92400E" }}>
        🖼️ {label || "صورة الرسالة مطلوبة (قالب مصوَّر)"} — JPEG/PNG · ≤ 5MB
      </label>
      {/* زر مرئي يشغّل المدخل — index.css:1099 يضبط input[type=file]{display:none} عالميًا */}
      <button type="button" data-testid={`${testidPrefix}-pick`} disabled={busy}
        onClick={() => fileRef.current?.click()}
        style={{ justifySelf: "start", fontSize: 12, fontWeight: 800, color: "#92400E",
          background: "#fff", border: "1px solid #F5D9B0", borderRadius: 8, padding: "6px 12px",
          cursor: busy ? "wait" : "pointer" }}>
        📎 {value ? "تغيير الصورة" : "اختر صورة"}
      </button>
      <input ref={fileRef} data-testid={`${testidPrefix}-file`} type="file"
        accept="image/jpeg,image/png" onChange={onFile} style={{ display: "none" }} />
      {busy && <span data-testid={`${testidPrefix}-busy`} style={{ fontSize: 11, color: "#B45309" }}>⏳ يُرفع…</span>}
      {err && <span data-testid={`${testidPrefix}-error`} style={{ fontSize: 11, color: "#B91C1C", fontWeight: 700 }}>⚠ {err}</span>}
      {value && !busy && !err && (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {preview && <img data-testid={`${testidPrefix}-preview`} src={preview} alt="" style={{ width: 46, height: 46, objectFit: "cover", borderRadius: 8, border: "1px solid #F5D9B0" }} />}
          <span data-testid={`${testidPrefix}-ready`} style={{ fontSize: 11, color: "#166534", fontWeight: 700 }}>✓ {readyNote || "جاهزة (صالحة 30 يومًا)"}</span>
        </div>
      )}
    </div>
  );
}
